import React, { useState, useEffect } from "react";
import Header from "../../component/loaderComponent/Header/Header";
import Sidebar from "../Sidebar";
import './rewardredeem.scss'
import { useNavigate } from "react-router-dom";
import { HiMenu, HiX } from "react-icons/hi";
import { MOBILE_BREAKPOINT,HTTP_STATUS } from "../../constants/constant";
import { encode } from "base-64";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import { useDispatch } from "react-redux";
import { getrewardredeemAction, searchdataRewardredeem, pagedataRewardredeem } from "../../actions/rewardAction";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useSelector } from "react-redux";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import NoDataFound from "../../component/noDataComponent/NoDataFound";
import { constant } from "../../constants/constant";
import useMobileView from "../../constants/useMobileView";


function RewardRedeem() {
  const [RewardRedeemList, setRewardRedeemList] = useState([]);
  const searchdata = useSelector((state) => state.redeemsearch);
  const { isMobileView, isSidebarOpen, toggleSidebar } = useMobileView();

  const pagedata = useSelector((state) => state.redeempage)
  
  const [searched, setsearched] = useState(searchdata?.searchfaqdata?.data);
  const [page, setPage] = useState(pagedata?.page);
  const [count, setCount] = useState(1)
  const [loading, setloading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    getRewardsData();
  }, [page]);

  

  const onAddclick = () => {
    navigate("/add_rewardredeem")
  }

  const handleChange = (evt) => {
    const value = evt.target.value;
    setsearched(value.replace(/^ +/gm, ""));
    // setPage(1)
    dispatch(searchdataRewardredeem(value));
    if (value.length === 0) {
      window.location.reload()
    }
  }

  const onEditclick = (Id) => {
    window.scroll(0, 0);
    const encodeid = encode(Id);
    navigate(`/edit_rewardredeem/${encodeid}`);
  }

  async function getRewardsData() {
    setloading(true);
    if (searched == "") {
      var response = await dispatch(getrewardredeemAction(page));
    } else {
      var response = await dispatch(getrewardredeemAction(page, searched));
    }
    if (response == 200 || response != null) {
      setCount(Math.ceil(response.data.count / 10));
      setRewardRedeemList(response.data.results.data);
      setpaginationListcount(response.data.count);
      setloading(false);
    } else if (response === undefined) {
      setloading(false);
    }

  }

  async function handlesearchclick() {
    const defaultpage = 1;
    dispatch(pagedataRewardredeem(1));
    setloading(true);
    dispatch(searchdataRewardredeem(searched));
    let response = await dispatch(getrewardredeemAction(defaultpage, searched));
    if (response == 200 || response != null) {
      setCount(Math.ceil(response.data.count / 10));
      setRewardRedeemList(response.data.results.data)
      setpaginationListcount(response.data.count);
      setloading(false);
    } else if (response === undefined) {
      setloading(false);
    }
  }

  const handlePagiChange = (event, value) => {
    dispatch(pagedataRewardredeem(value));
    setPage(value);
  };

  const [paginationListcount, setpaginationListcount] = useState(0);

  const startItem = RewardRedeemList?.length === 0 ? 0 : (page - 1) * constant.paginationCount + 1;
  const endItem = Math.min(page * constant.paginationCount, paginationListcount);

  return (
    <div className="rewardredeem_conatiner">
      <div className="rewardredeem_conatiner_right">
        <Header title="Reward Redeem" />
        <div className="reward_containers_redmee">
          <div className="reward_redeem">
            <div className="reward_search_container">
              <input className="reward_redeem_search" type="text" placeholder="Coupon Variable" name="searched" value={searched} onChange={handleChange} />
              <button className="reward_redeem_submit_button" disabled={!searched} onClick={handlesearchclick}>Search</button>
            </div>
            <div className="reward_search_container">
              <button className="reward_redeem_add_button" onClick={onAddclick}> Add</button>
            </div>
          </div>
          <div className="reward_redeem_table">
            {loading ? <Loader /> : (
              <div>
                {RewardRedeemList?.length > 0 ?
                  <div className="tabledata">
                    <table className="table">
                      <tr>
                        <th className="tablesth">Coupon Variable </th>
                        <th className="tablesth">Product description </th>
                        <th className="tablesth">Amount</th>
                        <th className="tablesth">Action</th>
                      </tr>
                      {RewardRedeemList.map((item) =>
                        <tr>
                          <td className="tabletd">{item.product_code}</td>
                          <td className="tabletd">{item.product_description}</td>
                          <td className="tabletd">{item.points}</td>
                          <td className="tabletdV">
                            <div className="card_profile_controls">
                              <img
                                src={Image_Url.EDIT}
                                className="editicons"
                                onClick={() => { onEditclick(item.id); }}
                              />
                            </div>
                          </td>
                        </tr>
                      )}
                    </table>
                  </div>
                  : <NoDataFound />}
              </div>)}
            <div className="Pagination_section">
              <Stack spacing={2} >
                <Pagination
                  count={count}
                  className="pagination"
                  page={page}
                  size="medium"
                  defaultPage={1}
                  color="primary"
                  onChange={handlePagiChange}
                />
              </Stack>
              <div className="count">
                  <b>
                    <span>Displaying {startItem} to {endItem} out of {paginationListcount}</span>
                    </b>
                  </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default RewardRedeem;